<template>
  <div class="footerBottom">
    <footer class="footer flex_around">
      <router-link to="/m_home" class="footer_li flex_center">
        <i v-if="headIndex == 1"><img src="@/assets/img/ceshi/a_icon_sy.png" alt="" /></i>
        <i v-else><img src="@/assets/img/ceshi/icon_sy.png" alt="" /></i>
        <span>首页</span>
      </router-link>
      <router-link to="" class="footer_li flex_center"  v-if="USER().id == undefined || USER().check_status == undefined || USER().check_status != 1"  @click.native="note">
        <i v-if="headIndex == 2"><img src="@/assets/img/ceshi/a_icon_wz.png" alt="" /></i>
        <i v-else><img src="@/assets/img/ceshi/icon_wz.png" alt="" /></i>
        <span>文章</span>
      </router-link>
      <router-link to="/m_column" class="footer_li flex_center" v-else>
        <i v-if="headIndex == 2"><img src="@/assets/img/ceshi/a_icon_wz.png" alt="" /></i>
        <i v-else><img src="@/assets/img/ceshi/icon_wz.png" alt="" /></i>
        <span>文章</span>
      </router-link>
      <router-link to="/m_index" class="footer_li live" :class="{ selected: headIndex == 3 }">
        <i v-if="headIndex == 3"><img src="@/assets/img/ceshi/a_icon_zb.png" alt="" /></i>
        <i v-else><img src="@/assets/img/ceshi/icon_zb.png" alt="" /></i>
      </router-link>
      <router-link to="/m_vedio_index" class="footer_li flex_center">
        <i v-if="headIndex == 4"><img src="@/assets/img/ceshi/a_icon_sp.png" alt="" /></i>
        <i v-else><img src="@/assets/img/ceshi/icon_sp.png" alt="" /></i>
        <span>视频</span>
      </router-link>
      <router-link :to="{name:'m_my'}" class="footer_li flex_center">
        <i v-if="headIndex == 5"><img src="@/assets/img/ceshi/a_icon_wd.png" alt="" /></i>
        <i v-else><img src="@/assets/img/ceshi/icon_wd.png" alt="" /></i>
        <span>我的</span>
      </router-link>
    </footer>
   <!-- 提示注册弹窗 -->
    <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
    <LoginPrompt1 @promptFun1="promptFun1" ref="prompt1"></LoginPrompt1>
  </div>
  
</template>

<script>
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import LoginPrompt1 from "@/components/assembly/LoginPrompt1.vue"; //注册弹窗模块
export default {
  name: "footerBottom",
  data() {
    return {
      is_login: false, //是否显示登录
      user: {}, //用户信息

      is_agreement: false, //用户协议
      is_privacy: false, //显示隐私
      is_clik: false,
    };
  },
  components: {
    LoginPrompt,
    LoginPrompt1
  },
  props: ["headIndex"],
  methods: {
    note(){
      if (this.USER().id == undefined) {
          this.prompt1Show();
          return false;
        }else{
          console.log(this.USER(),'cjheck')
          if(this.USER().check_status != 1){
            this.prompt2Show();
            return false;
          }
        }
    },
     promptFun1(){
      this.registered(1);
    },
    prompt1Show() {
      //打开提示弹窗回调
      this.$refs.prompt1.popupFun1();
    },
    prompt2Show() {
      //打开审核状态提示语弹窗回调
      this.$refs.prompt1.popupFun2();
    },
    //   底部板块弹窗
    onpenban() {
      this.is_clik = !this.is_clik;
    },
    // 跳转文章
    goartic() {
      this.$router.replace("/m_column");
    },
    govedio() {
      this.$router.replace("/m_vedio_index");
    },
    promptFun() {
      //提示弹窗回调
      this.registered(3);
    },
    promptShow() {
      //打开提示弹窗回调
      this.$refs.prompt.popupFun();
    },
    privacyFun(index) {

      if (index == 1) {
        this.is_agreement = !this.is_agreement;
      }
      if (index == 2) {
        this.is_privacy = !this.is_privacy;
      }
    },
    getUser() {
      //获取用户数据
      this.user = this.USER();
      this.$emit("is_judge");
    },
    registered(index) {
      //1登录 3注册
      this.$refs.login.loginFun(index);
      this.is_login = true;
    },
    personal() {
      //个人中心
      this.$router.replace("/personal");
    },
    goHome() {
      //跳转首页
      this.$router.push("/");
    },
  },
  mounted() {
    this.user = this.USER();
    // this.getUser();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
<style scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  /* padding: 0 1.3rem; */
  align-items: center;
  z-index: 95;
  background: #fff;
  box-shadow: 0 0 9px rgba(71, 71, 71, 0.11);
}

html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

.footer_li {
  width: 18%;
  flex-direction: column;
}

.footer_li > i {
  width: 8vw;
  margin: 0 auto;
}

.footer_li > span {
  font-size: 3.5vw;
  color: #333;
  text-align: center;
}

.footer_li.live > i {
  width: 4rem;
  height: 4rem;
}

.footer_li.live > i > img {
  /* width: 2.8rem;
        height: 2.8rem; */
  width: 4rem;
  height: 4rem;
}

.footer_li.live.selected > i {
  border-color: #f24d5b;
}
.floatpo {
  position: absolute;
  top: -18.5vw;
  width: 100%;
  height: 15vw;
  text-align: center;
  background-color: #f6f6f6;
}
.floatpo::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -1.3vw;
  transform: translateX(-50%) rotateZ(45deg);
  width: 3vw;
  height: 3vw;
  background-color: #f6f6f6;
}
.floatpo div {
  padding-bottom: 1vw;
  padding-top: 2vw;
}
.floatpo span {
  font-size: 3vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #414141;
  opacity: 1;
}
.footer_li i img {
  width: 6.93vw;
  height: 6.93vw;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/m_assembly/MinFooter.vue